import React from 'react';

/**
 * DetailImpactLeftText
 * 
 * Displays the left textual content and link for the Sustainability (Impact) section.
 * Encapsulates the ALLIED VERIFIED IMPACT score or "JOIN POW" link.
 */
export const DetailImpactLeftText = ({ impactData, t }) => {
  if (impactData) {
    return (
      <div className="mr-impact-score">
        <p className="spec-title">{t("impact.verified_impact")}</p>
        <p className="spec-value">{impactData.total.toFixed(5)}</p>
        <p className="spec-measure">{t("impact.kg_co2")}</p>
      </div>
    );
  }
  return null;
};
